import { forwardRef } from 'react';
import {
  styled,
  CardActionArea,
  cardActionAreaClasses,
  touchRippleClasses,
  Typography,
  IconButtonProps,
  IconButton,
} from '@mui/material';
import { lighten, darken } from '@mui/material/styles';

export const DashboardVariantV2CarrierStatusInfoWidgetCardContainer = styled(
  CardActionArea,
  {
    shouldForwardProp: (prop) =>
      prop !== 'accentColor' && prop !== 'isSelected',
  },
)<{ accentColor: string; isSelected: boolean }>(
  ({ theme, accentColor, isSelected }) => ({
    width: '100%',
    padding: theme.spacing(1.5, 2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    borderRadius: 12,
    backgroundColor: theme.palette.common.white,
    justifyContent: 'flex-start',
    border: '1px solid transparent',
    transition: theme.transitions.create(['background-color', 'border-color'], {
      duration: theme.transitions.duration.standard,
    }),

    ...(isSelected && {
      backgroundColor: lighten(accentColor, 0.8),
      borderColor: darken(accentColor, 0.4),
    }),

    [`&:hover .${cardActionAreaClasses.focusHighlight}`]: {
      color: accentColor,
    },

    [`& .${touchRippleClasses.ripple}.${touchRippleClasses.rippleVisible}`]: {
      color: accentColor,
    },
  }),
);

export const DashboardVariantV2CarrierStatusInfoWidgetCardTypographyCurrent =
  styled(Typography)(({ theme }) => ({
    fontSize: theme.typography.pxToRem(40),
    fontWeight: theme.typography.fontWeightBold,
    lineHeight: theme.typography.pxToRem(40),
  }));

export const DashboardVariantV2CarrierStatusInfoWidgetCardTypographyTotal =
  styled(Typography)(({ theme }) => ({
    fontSize: theme.typography.pxToRem(26),
    fontWeight: theme.typography.fontWeightMedium,
    lineHeight: theme.typography.pxToRem(26),
  }));

export const DashboardVariantV2CarrierStatusInfoWidgetCardIconImg = styled(
  'img',
)({
  width: 50,
  height: 50,
});

export const DashboardVariantV2CarrierStatusInfoWidgetCardButtonIcon = styled(
  forwardRef<HTMLSpanElement, IconButtonProps>(
    function DashboardVariantV2CarrierStatusInfoWidgetCardButtonIcon(
      inProps,
      ref,
    ) {
      return (
        <IconButton
          {...inProps}
          ref={ref}
          component="span"
          disableFocusRipple
          disableRipple
          disableTouchRipple
        />
      );
    },
  ),
)(({ theme }) => ({
  padding: 0,
  fontSize: theme.typography.pxToRem(28),
}));
